import { Component, OnInit } from '@angular/core';
import { PlatformsResponse } from 'src/app/domains/integrations/models/integrations.model';
import { IntegrationsService } from 'src/app/domains/integrations/services/integrations.service';
import { Integration, IntegrationPlatform, IntegrationsFilters, IntegrationsResponse } from 'voxloud-types/dist/models/integrations';

const PAGE_SIZE = 20;

@Component({
  selector: 'gdp-integrations-main',
  templateUrl: './integrations-main.component.html',
  styleUrls: ['./integrations-main.component.scss']
})
export class IntegrationsMainComponent implements OnInit {
  loading: boolean;
  filters: IntegrationsFilters;
  public integrations: Integration[];
  public platforms: IntegrationPlatform[];
  public pageSize: number;
  public authMethodsType;
  public pagination = {
    page: 0,
    empty: true,
    totalPages: 0
  };
  public sameFilters: boolean;

  constructor(
    private integrationsService: IntegrationsService
  ) {}

  ngOnInit() {
    this.pageSize = PAGE_SIZE;
    this.fetchPlatforms();
    this.fetchIntegrations();
    this.authMethodsType = this.integrationsService.authMethods;
  }


  filterChanged(event: IntegrationsFilters) {
    if (this.areNotEmptyFilters(event)) {
      this.filters = event;
    } else {
      this.filters = null;
    }
    this.sameFilters = false;
    this.fetchIntegrations();
  }

  areNotEmptyFilters(event) {
    return event.company_id !== '' ||
      event.status !== '' ||
      event.platform_id !== '' ||
      event.enabled !== ''
  }

  selectPageSize(event) {
    this.pageSize = event;
    this.pagination.page = 0;
    this.fetchIntegrations();
  }

  changeCurrentPage(event) {
    this.pagination = {
      page: event,
      empty: this.integrations.length === 0,
      totalPages: this.pagination.totalPages
    }
    this.fetchIntegrations();
  }

  fetchIntegrations() {
    if (this.filters && !this.sameFilters) {
      this.pagination.page = 0;
    } else {
      this.pagination.page = this.pagination.page;
    }
    this.sameFilters = true;
    this.loading = true;
    this.integrationsService.getIntegrationsByFilter(this.pagination.page, this.pageSize, this.filters).subscribe(
      (response: IntegrationsResponse) => {
        this.integrations = response.content;
        this.integrations.length !== 0 ? this.pagination.totalPages = response.totalPages : this.pagination.totalPages = 1;
        this.loading = false;
      }, 
      () => {
        this.integrations = [];
        this.loading = false;
      });
  }

  fetchPlatforms() {
    this.loading = true;
    this.integrationsService.getAllPlatforms().subscribe(
      (response: PlatformsResponse) => {
        this.platforms = response.content;
        this.loading = false;
      },
      () => {
        this.platforms = [];
        this.loading = false;
      }
    )
  }
}
